import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { map } from 'rxjs';
import { TreetopPropertiesProvider } from 'shared/util-common';

import { PaginationWrapperDto } from '@treetop/shared/model';

import { AttachmentFullTextFilter, AttachmentSearchResult } from './attachment-search.model';

@Injectable({ providedIn: 'root' })
export class AttachmentSearchHttpService {
  private http = inject(HttpClient);
  private readonly baseUrl = `${TreetopPropertiesProvider.properties.baseUrl}api/attachments/full-text`;

  /**
   * Gets search results based on text and page number.
   * @param filter - Search text and filters
   * @param page - Page number (defaults to 1)
   */
  public getSearchResult(filter: AttachmentFullTextFilter, page = 1, onlySearchHome = false) {
    const params = new HttpParams()
      .set('searchText', filter.searchText)
      .set('page', page.toString())
      .set('searchInAllOrganizations', onlySearchHome ? 'false' : 'true');

    return this.http.get<PaginationWrapperDto<AttachmentSearchResult>>(this.baseUrl, { params }).pipe(
      map((response) => ({
        list: response.list ?? [],
        page: response.page,
        itemsPerPage: response.itemsPerPage,
        maxPage: response.maxPage,
        maxElements: response.maxElements,
      })),
    );
  }
}
